import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    minHeight: '100%',
    paddingTop: '10vh',
    flexDirection: 'column',
    paddingBottom: 80,
    [theme.breakpoints.down('sm')]: {
      paddingTop: '5vh',
      paddingBottom: 20,
      height: 'fit-content',
      scale: 0.9,
    },
  },
  boxButtons: {
    gap: theme.spacing(2),
  },
  boxFinish: {
    height: '50vh',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      height: 'fit-content',
    },
  },
}))

export default styles
